import '../../styles/App.scss';
import '../../styles/variables.scss';
import './menu-left.scss';
//react
import { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';

//shared
import { SkeletonMenu } from '../shared/components/skeleton-menu/skeleton-menu';
import ClassBranch from '../class-branch/class-branch';
import ReportsBranch from '../reports-branch/reports-branch';
import History from '../history/history';
import Comments from '../comments/comments';
import { BRANCH, CHECK_BRANCH_NATURAL_PERSON } from '../shared/graphql/branch';
import { Menu } from './components/Menu';
import ModalQuestion from '../shared/components/modal-question/modal-question';

//material
import Grid from '@mui/material/Grid';
import Attendance from '../attendance/attendance';
import ChangesAndConfigurations from '../changes-config/changes-config';

function GetCheckNatural({ branchId }: { branchId: number }) {
    const { data, error } = useQuery(CHECK_BRANCH_NATURAL_PERSON, {
        variables: { branchId: branchId },
    });

    if (data && !data.checkBranchNaturalPerson.success) {
        return <ModalQuestion branchId={branchId}></ModalQuestion>
    };
    if (error) console.log(`Submission error! ${error.message}`);

    return <></>;
}

function MenuLeft() {
    // const navigate = useNavigate();
    const [section, changeSection] = useState(0);

    const params = useParams();

    const { data, loading, error } = useQuery(BRANCH);

    if (loading) return <SkeletonMenu></SkeletonMenu>;
    if (error) console.log(`Submission error! ${error.message}`);

    const branches = data.branchesProvider;
    const branch = parseInt(params.id!);

    if (!branches.some((item: any) => item.id === branch)) {
        return <Navigate to="/branch" />;
    }

    return (
        <>
            <Grid container className="container mt-5 container-menu-top" style={{ minWidth: "1300px !important" }} >
                <Grid item xs={12} sm={12} md={4} className="menu-container">
                    <Menu section={section} branches={branches} branch={branch} changeSection={(sectionChange: number) => changeSection(sectionChange)} />
                </Grid>
                <Grid item xs={12} sm={12} md={8}>
                    {(() => {
                        switch (section) {
                            case 0:
                                return <ClassBranch key={branch} branch={branch} />
                            case 1:
                                return <Attendance key={branch} branch={branch} />
                            case 2:
                                return <History key={branch} branch={branch} />
                            case 3:
                                return <ReportsBranch key={branch} branch={branch} />
                            case 4:
                                return <Comments key={branch} branch={branch} />
                            case 5:
                                return <ChangesAndConfigurations key={branch} branch={branch}/>
                            default:
                                break;
                        }
                    })()}
                </Grid>
                <GetCheckNatural branchId={branch}></GetCheckNatural>
            </Grid>
        </>
    );
}

export default MenuLeft;